import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import axios from 'axios';

const OAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const response = searchParams.get('response');
        // ROUVY возвращает причину отказа в reason (а не в error/error_description)
        const reason = searchParams.get('reason');

        if (response === 'error') {
          const details = reason ? ` (${reason})` : '';
          throw new Error(`${t('rouvy.accessDenied')}${details}`);
        }

        if (!code || !state) {
          throw new Error(t('rouvy.missingParams'));
        }

        if (response !== 'success') {
          throw new Error(t('rouvy.authFailed'));
        }

        // Отправляем данные на backend для обработки
        const backendResponse = await axios.get('/api/rouvy/callback', {
          params: { code, state, response }
        });

        // Если backend вернул успешный ответ, редиректим на профиль
        navigate('/profile?rouvy_connected=success', { replace: true });
      } catch (err) {
        console.error('OAuth callback error:', err);
        const errorMessage = err.response?.data?.error || err.message || 
          t('rouvy.connectionError');
        setError(errorMessage);
        
        // Через 3 секунды редиректим на профиль с ошибкой
        setTimeout(() => {
          navigate(`/profile?rouvy_error=${encodeURIComponent(errorMessage)}`, { replace: true });
        }, 3000);
      } finally {
        setProcessing(false);
      }
    };

    handleCallback();
  }, [searchParams, navigate, t]);

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        padding: '20px'
      }}>
        <div style={{
          backgroundColor: 'var(--c-ffeeee-bg)',
          border: '1px solid var(--c-ffcccc-bd)',
          borderRadius: '8px',
          padding: '20px',
          maxWidth: '500px',
          textAlign: 'center'
        }}>
          <h2 style={{ color: 'var(--c-cc0000-fg)', marginBottom: '10px' }}>
            ❌ {t('common.error')}
          </h2>
          <p style={{ marginBottom: '15px' }}>{error}</p>
          <p style={{ fontSize: '14px', color: 'var(--c-666666-fg)' }}>
            {t('rouvy.redirectingToProfile')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px',
      padding: '20px'
    }}>
      <div style={{
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px',
          animation: 'spin 1s linear infinite'
        }}>
          ⏳
        </div>
        <h2 style={{ marginBottom: '10px' }}>
          {t('rouvy.connectingRouvy')}
        </h2>
        <p style={{ color: 'var(--c-666666-fg)' }}>
          {t('rouvy.pleaseWait')}
        </p>
      </div>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default OAuthCallback;